module.exports = __webpack_public_path__ + "media/mii-brawler.d80af2b7.wav";